module["exports"] = ["/30[0-5]#-######-###L/", "/368#-######-###L/"];